import { handleAuthorization, handleOkResponseJson, handleBadRequest400, apiFetch } from "./handlers"
import { obterToken } from "./loginService"
import { normalizeTextUppercase } from "../utils"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';

export const obterOrdensServicoAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/OrdemServico/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarOrdemServicoAsync = async (tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista,
          idLocalizacao, informacoesAdicionais, dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, 
          idLocalizacao, informacoesAdicionais: normalizeTextUppercase(informacoesAdicionais), dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/OrdemServico`, requestOptions);
}

export const editarOrdemServicoAsync = async (id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, 
          idLocalizacao, informacoesAdicionais, dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, idLocalizacao, 
            informacoesAdicionais: normalizeTextUppercase(informacoesAdicionais), dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/OrdemServico/atualizar`, requestOptions);
}
export const executarOrdemServicoAsync = async (id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista,  
          idLocalizacao, informacoesAdicionais, dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, idLocalizacao, 
            informacoesAdicionais: normalizeTextUppercase(informacoesAdicionais), dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/OrdemServico/executar`, requestOptions);
}
export const finalizarOrdemServicoAsync = async (id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista,  
          idLocalizacao, informacoesAdicionais, dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, idLocalizacao, 
            informacoesAdicionais: normalizeTextUppercase(informacoesAdicionais), dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/OrdemServico/finalizar`, requestOptions);
}
export const autorizarOrdemServicoAsync = async (id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, 
          idLocalizacao, informacoesAdicionais, dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, idLocalizacao, 
            informacoesAdicionais: normalizeTextUppercase(informacoesAdicionais), dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/OrdemServico/autorizar`, requestOptions);
}
export const naoAutorizarOrdemServicoAsync = async (id) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/OrdemServico/naoAutorizar`, requestOptions);
}
export const inativarOrdemServicoAsync = async (id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista,  
          idLocalizacao, informacoesAdicionais, dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, justificativa, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, tipoOS, prioridade, idUnidadeAdm, idEquipamento, idPlanoManutencao, idPeriodicidade, idMecanico, idLubrificador, idEletricista, idLocalizacao, 
            informacoesAdicionais: normalizeTextUppercase(informacoesAdicionais), dataInicial, dataFinal, horaInicial, horaFinal, horimetroInicial, horimetroFinal, justificativa, itens })
    };
    return apiFetch(`${process.env.VUE_APP_API_URL}/OrdemServico/inativar`, requestOptions);
}

export function getPdf(id, janelaPdf = null) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/OrdemServico/downloadPdf/` + id,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            fecharJanelaPdf(janelaPdf);
            return { status: false };
        })
            .then((response) => {
                if (response.status === false) {
                    fecharJanelaPdf(janelaPdf);
                    return response;
                }
                abrirBlobPdf(response.data, janelaPdf);
            });
    } catch (e) {
        fecharJanelaPdf(janelaPdf);
        throw e;
    }
}

export const obterMetricasAsync = async () => {
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
  };

  return fetch(`${process.env.VUE_APP_API_URL}/OrdemServico/metricas`, requestOptions)
    .then(handleAuthorization)
    .then(handleOkResponseJson)
    .then(result => result.data);
}
